// CB:BEGIN responsive-container
import React from 'react';
import { useDevice } from '../../hooks/useDevice';

interface ResponsiveContainerProps {
  children: React.ReactNode;
  className?: string;
  headerOffsetPx?: number;
}

const ResponsiveContainer: React.FC<ResponsiveContainerProps> = ({ children, className, headerOffsetPx = 0 }) => {
  const { safeAreaTop, safeAreaBottom } = useDevice();
  const topPad = Math.max(0, safeAreaTop) + headerOffsetPx;
  const bottomPad = Math.max(0, safeAreaBottom);
  return (
    <div
      className={className}
      style={{
        paddingTop: topPad,
        paddingBottom: bottomPad,
        minHeight: '100svh',
      }}
    >
      {children}
    </div>
  );
};

export default ResponsiveContainer;
// CB:END responsive-container

